import { NavListItem, NavListSection } from "#root/components/nav-list";
import Sidebar from "#root/components/sidebar";
import type { ReactNode } from "react";
import { MdLanguage, MdLockReset, MdReceipt, MdRssFeed, MdSettings } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { WithSidebar } from "../../components/withSidebar";
import Layout from "../layout";

export type AccountLayoutProps = Parameters<typeof Layout>[0] & {
  invoiceElements?: ReactNode | undefined;
  deploymentElements?: ReactNode | undefined;
  syndicatedContentElements?: ReactNode | undefined;
};

export default function ({ children, invoiceElements, deploymentElements, syndicatedContentElements, ...props }: AccountLayoutProps): ReactNode {
  return (
    <Layout {...props}>
      <WithSidebar>
        <Sidebar>
          <NavLink to="/account/password">
            <NavListItem icon={MdLockReset}>Change Password</NavListItem>
          </NavLink>
          <NavLink to="/account/deployment">
            <NavListItem icon={MdLanguage}>Deployments</NavListItem>
          </NavLink>
          {deploymentElements ? <NavListSection>{deploymentElements}</NavListSection> : null}
          <NavLink to="/account/invoice">
            <NavListItem icon={MdReceipt}>Invoices</NavListItem>
          </NavLink>
          {invoiceElements ? <NavListSection>{invoiceElements}</NavListSection> : null}
          <NavLink to="/account/profile">
            <NavListItem icon={MdSettings}>My Profile</NavListItem>
          </NavLink>
          <NavLink to="/account/syndicatedContent">
            <NavListItem icon={MdRssFeed}>Syndicated Content</NavListItem>
          </NavLink>
          {syndicatedContentElements ? <NavListSection>{syndicatedContentElements}</NavListSection> : null}
        </Sidebar>
        {children}
      </WithSidebar>
    </Layout>
  );
}
